export default __webpack_public_path__ + "static/media/tap_button_able.583cfe2d.png";